import React from "react";
import { Link } from "react-router-dom";
import "../../../../sass/files/gallery.scss";
import Carousel from "./component/ReviewCarousel";

const Review = () => {
  const openReviewsFromTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    const appContainer = document.querySelector(".App");

    if (appContainer) {
      appContainer.scrollTop = 0;
    }
  };

  return (
    <div>
      <section className="hero gallery-section">
        <div className="hero-body">
          <p className="gallery-title mb-8">
            Our Testimonials
          </p>

          <div
            className="grid grid-cols-1 gap-4 items-center"
            id="review"
          >
            <div className="flex items-center flex-cols">
              <Carousel />
            </div>

            <div className="trustpilot-section">
              <Link
                to="/review"
                className="trustpilot-btn"
                onClick={openReviewsFromTop}
              >
                View All Reviews →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Review;